module.exports = __webpack_public_path__ + "img/checkup_tc_v3.df638ede.png";